export class UserTypeEnum {
  static readonly ADMIN = 'ADM';
  static readonly OPR = 'OPR';
  static readonly SUS = 'SUS';
  static readonly USER = '';
}
